import React from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Fieldset from "../../common/Fieldset";
import Row from "../../common/Row";
import Col from "../../common/Col";
import Table from "../../common/Table";
import Toelating from "../shared/Toelating";

const ToelatingPerGemeenteForm = (props) => {
	const {
		model,
		bewijsstukkenFileTypes,
		fileComponents,
		getError,
		onUploadFiles,
		onDeleteFile,
		downloadFileUrl,
		onChange,
		onSave,
		onAnnuleer,
		disabled,
		color,
		validationMessageType
	} = props;

	const overlappingen = model.overlappingen || [];
	const overlappingenSection = overlappingen.length ? (
		<Fieldset title={"Overlappingen met andere tochten"}>
			<Row>
				<Col size={12}>
					<p style={{ marginBottom: "10px" }}>Er lopen 1 of meerdere andere tochten op dezelfde dag over (een deel van) dezelfde route.</p>
				</Col>
			</Row>
			<Row>
				<Col size={12}>
					<Table
						headers={["Type tocht", "Tocht", "Organisator"]}
						headerSizes={[25, 50, 25]}
					>
						{overlappingen.map((overlapping, index) => (
							<tr key={"overlapping_" + index}>
								<td>{overlapping.tochtType}</td>
								<td>{overlapping.dossiernummer} {overlapping.tochtNaam}</td>
								<td>{overlapping.organisator}</td>
							</tr>
						))}
					</Table>
				</Col>
			</Row>
		</Fieldset>
	) : null;

	return (
		<Form name="Goedkeuringen"
			headerVisible={false}
			leftButtonLabel={"Bewaar"}
			onLeftButtonClick={onSave}
			leftButtonDisabled={disabled}
			rightButtonLabel={"Annuleer"}
			onRightButtonClick={onAnnuleer}
			color={color}
			isNotRequired>
			{overlappingenSection}
			<Toelating
				model={model.toelating}
				bewijsstukkenFileTypes={bewijsstukkenFileTypes}
				onDropFiles={onUploadFiles}
				onDeleteFile={onDeleteFile}
				fileComponents={fileComponents}
				downloadFileUrl={downloadFileUrl}
				getError={getError}
				onChange={onChange}
				key={model.id}
				disabled={disabled}
				color={color}
				validationMessageType={validationMessageType}
				hideTitle
				heeftBepijling={model.heeftBepijling}
			/>
		</Form>
	);
};

ToelatingPerGemeenteForm.propTypes = {
	model: PropTypes.object,
	bewijsstukkenFileTypes: PropTypes.object.isRequired,
	fileComponents: PropTypes.object.isRequired,
	getError: PropTypes.func.isRequired,
	onUploadFiles: PropTypes.func.isRequired,
	onDeleteFile: PropTypes.func.isRequired,
	downloadFileUrl: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	onAnnuleer: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	color: PropTypes.string,
	validationMessageType: PropTypes.string

};

export default ToelatingPerGemeenteForm;
